var React = require('react');

function Forum (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.69316 27.0007C8.27649 27.0007 7.88991 26.8178 7.53341 26.452C7.17693 26.0863 6.9987 25.6951 6.9987 25.2784V21.4451H28.1098V7.00065H31.9987C32.4154 7.00065 32.7973 7.18353 33.1445 7.54928C33.4918 7.915 33.6654 8.31546 33.6654 8.75065V33.6395L27.0265 27.0007H8.69316ZM0.332031 25.334V2.05619C0.332031 1.63953 0.505642 1.24833 0.852865 0.882609C1.20009 0.516859 1.58203 0.333984 1.9987 0.333984H23.6376C24.0728 0.333984 24.464 0.512221 24.8112 0.868693C25.1584 1.22519 25.332 1.62103 25.332 2.05619V16.9451C25.332 17.3618 25.1584 17.753 24.8112 18.1187C24.464 18.4844 24.0728 18.6673 23.6376 18.6673H6.9987L0.332031 25.334ZM22.5543 15.8896V3.11174H3.10978V15.8896H22.5543Z","fill":"#064861"}));
}

Forum.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = Forum;

Forum.default = Forum;
